import _ from 'lodash';
import { graph } from '@adc/constants';
import { formatMoney } from '../../../../utils/formatters';
import interpolateString from '../../../../utils/interpolateString';
import ListingBadge, { BADGE_ORDER_PRIORITY, BADGE_MODE } from './base';
import { isTPSOnline, isREO } from './utils';
const buyersPremiumAvailableValueReceived = listing => Object.prototype.hasOwnProperty.call(listing.listing_configuration || {}, 'is_buyers_premium_available') ||
    Object.prototype.hasOwnProperty.call(listing.listing_configuration || {}, 'buyer_premium_available');
const isBuyersPremiumAvailable = listing => listing.listing_configuration?.buyer_premium_available ||
    listing.listing_configuration?.is_buyers_premium_available;
const premiumMinimumAmount = listing => listing.program_configuration?.buyers_premium_minimum_amount;
const premiumPrimaryAmount = listing => listing.program_configuration?.buyers_premium_primary_amount;
const hasPremiumStrategySet = listing => premiumMinimumAmount(listing) > 0 || premiumPrimaryAmount(listing) > 0;
const hasZeroBuyersPremiumState = listing => premiumMinimumAmount(listing) === 0 && premiumPrimaryAmount(listing) === 0;
const BUYERS_PREMIUM_EXPLANATIONS = {
    MESSAGE: 'Winner will be charged a fee for this property. %s',
    FIXED_AMOUNT: '%s regardless of Winning Bid Amount.',
    PERCENTAGE_WITH_GUARANTEED_MINIMUM: '%s% of Winning Bid Amount (A minimum of %s will apply)',
};
class BuyerPremiumAvailableBadge extends ListingBadge {
    static title = "Buyer's Premium";
    static titleIcon = 'dollar-sign';
    static textIcon = 'times';
    static contentPositive = false;
    static summary = 'Applicable';
    static shouldBeIncluded(listing, badgeMode) {
        return (badgeMode === BADGE_MODE.EXPANDED &&
            isBuyersPremiumAvailable(listing) &&
            hasPremiumStrategySet(listing) &&
            (isTPSOnline(listing) || isREO(listing)));
    }
    get summary() {
        const { listing } = this.props;
        const buyersPremiumMinAmount = premiumMinimumAmount(listing);
        const buyersPremiumAmount = premiumPrimaryAmount(listing);
        const type = _.get(listing.program_configuration, 'buyers_premium_commission_type');
        return [
            type === graph.enums.CommissionStrategyType.PERCENTAGE &&
                buyersPremiumAmount
                ? `${buyersPremiumAmount}%`
                : '',
            buyersPremiumMinAmount ? formatMoney(buyersPremiumMinAmount) : '',
        ]
            .filter(Boolean)
            .join(' or ');
    }
    get content() {
        const { buyers_premium_commission_type, buyers_premium_minimum_amount, buyers_premium_primary_amount, } = this.props.listing.program_configuration || {};
        let suffix = '';
        if (buyers_premium_commission_type ===
            graph.enums.CommissionStrategyType.DOLLAR) {
            suffix = interpolateString(BUYERS_PREMIUM_EXPLANATIONS.FIXED_AMOUNT, [
                formatMoney(buyers_premium_primary_amount),
            ]);
        }
        else if (buyers_premium_commission_type ===
            graph.enums.CommissionStrategyType.PERCENTAGE) {
            suffix = interpolateString(BUYERS_PREMIUM_EXPLANATIONS.PERCENTAGE_WITH_GUARANTEED_MINIMUM, [
                buyers_premium_primary_amount,
                formatMoney(buyers_premium_minimum_amount),
            ]);
        }
        return interpolateString(BUYERS_PREMIUM_EXPLANATIONS.MESSAGE, [suffix]);
    }
}
class BuyerPremiumUnavailableBadge extends ListingBadge {
    static title = "Buyer's Premium";
    static titleIcon = 'dollar-sign';
    static condensedTitle = "No Buyer's Premium";
    static renderPriority = BADGE_ORDER_PRIORITY.FOURTH;
    static condensedTitleIcon = 'ban';
    static contentPositive = false;
    static content = "Winner will not be charged a Buyer's Premium for this property.";
    static summary = 'Not Applicable';
    static shouldBeIncluded(listing) {
        return ((isTPSOnline(listing) || isREO(listing)) &&
            ((buyersPremiumAvailableValueReceived(listing) &&
                !isBuyersPremiumAvailable(listing)) ||
                (isBuyersPremiumAvailable(listing) &&
                    hasZeroBuyersPremiumState(listing))));
    }
    get contentPositive() {
        return (isBuyersPremiumAvailable(this.props.listing) &&
            hasZeroBuyersPremiumState(this.props.listing));
    }
    get summary() {
        if (!isBuyersPremiumAvailable(this.props.listing)) {
            return null;
        }
        const amount = premiumMinimumAmount(this.props.listing);
        return _.isFinite(amount) ? formatMoney(amount) : null;
    }
}
export { BuyerPremiumAvailableBadge, BuyerPremiumUnavailableBadge };
//# sourceMappingURL=buyerPremium.js.map